/** Matches `.checklistRight { width: min(420px, 100vw) }` in applicationDetail.module.css */
export const APPLICATION_CHECKLIST_SIDEBAR_WIDTH_PX = 420

/** Gap between Credit Report tab end and the underwrite checklist panel start. */
export const APPLICATION_CHECKLIST_TAB_STRIP_GAP_PX = 0

/**
 * When the underwrite popup is open and the viewport is narrower than this,
 * Application detail tabs stay content-sized and scroll horizontally instead of compressing.
 */
export const APPLICATION_CHECKLIST_TAB_SCROLL_BELOW_PX = 1250
